import { render, staticRenderFns } from "./InventoryItem.vue?vue&type=template&id=48cf6622&scoped=true&"
import script from "./InventoryItem.vue?vue&type=script&lang=js&"
export * from "./InventoryItem.vue?vue&type=script&lang=js&"
import style0 from "./InventoryItem.vue?vue&type=style&index=0&id=48cf6622&lang=scss&scoped=true&"
import style1 from "./InventoryItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cf6622",
  null
  
)

export default component.exports